import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { deleteRecordatorio } from '../../routing/routes';
import LoadingGIF from '../assets/loading.gif';

const NoFlujo = ({ scriptsNoFlujo, recordatorios, permisos, setNotification, refreshData }) => {
	const [tabSelected, setTabSelected] = useState(0);
	const Menu = [MenuScriptsNoFlujo, MenuRecordatorios, MenuSeguimientos][tabSelected];
	return (
		<div>
			<div className='tabMenu' style={{ marginTop: 20, marginBottom: 15 }}>
				{true && (
					<div
						onClick={() => setTabSelected(0)}
						style={{ paddingTop: 5, paddingBottom: 5 }}
						className={tabSelected === 0 ? 'tabChild tabChild-selected' : 'tabChild'}
					>
						Scripts No Flujo
					</div>
				)}
				{true && (
					<div
						onClick={() => setTabSelected(1)}
						style={{ paddingTop: 5, paddingBottom: 5 }}
						className={tabSelected === 1 ? 'tabChild tabChild-selected' : 'tabChild'}
					>
						Recordatorios
					</div>
				)}
				{false && (
					<div
						onClick={() => setTabSelected(2)}
						style={{ paddingTop: 5, paddingBottom: 5 }}
						className={tabSelected === 2 ? 'tabChild tabChild-selected' : 'tabChild'}
					>
						Seguimiento
					</div>
				)}
			</div>
			<Menu scriptsNoFlujo={scriptsNoFlujo} recordatorios={recordatorios} permisos={permisos} setNotification={setNotification} refreshData={refreshData} />
		</div>
	);
};

export default NoFlujo;

const MenuScriptsNoFlujo = ({ scriptsNoFlujo, permisos }) => {
	const history = useHistory();
	return (
		<div>
			<h2 style={{ textAlign: 'center' }}>Scripts No Flujo</h2>
			{scriptsNoFlujo.map((script) => {
				return (
					<div key={script._id} className={'intent'} onClick={() => permisos.modificarScripts && history.push('/scripts/edit/noflujo/' + script._id)}>
						<h2 style={{ margin: 0, marginLeft: 30 }}>{script.tipoScript}</h2>
					</div>
				);
			})}
		</div>
	);
};

const MenuRecordatorios = ({ recordatorios, permisos, setNotification, refreshData }) => {
	const history = useHistory();

	const [recordatoriosLocal, setRecordatoriosLocal] = useState(recordatorios);

	useEffect(() => {
		setRecordatoriosLocal(recordatorios);
	}, [recordatorios]);

	const { global, genericos } = recordatoriosLocal;

	if (global) {
		return (
			<div style={{ position: 'relative' }}>
				{permisos.crearRecordatorios && (
					<Link to='/scripts/create/recordatorios/'>
						<button className='floatingButton'>+</button>
					</Link>
				)}
				<div>
					<h2 style={{ textAlign: 'center' }}>Recordatorios</h2>

					<div className={'intent'} onClick={() => permisos.modificarRecordatorios && history.push('/scripts/edit/recordatorios/' + global._id)}>
						<h2 style={{ margin: 0, marginLeft: 30 }}>{global.nombre}</h2>
					</div>

					{genericos.map((recordatorio) => {
						return (
							<div key={recordatorio._id} style={{ position: 'relative' }}>
								<div
									className={'intent'}
									onClick={() => permisos.modificarRecordatorios && history.push('/scripts/edit/recordatorios/' + recordatorio._id)}
								>
									<h2 style={{ margin: 0, marginLeft: 30 }}>{recordatorio.nombre}</h2>
								</div>
								{permisos.eliminarRecordatorios && (
									<button
										onClick={() => {
											deleteRecordatorio(recordatorio._id)
												.then(() => {
													refreshData();
													setNotification('mRecordatorio borrado correctamente');
												})
												.catch(() => {
													setNotification('eNo se ha podido borrar el recordatorio');
												});
										}}
										className='floatingButtonDelete'
									>
										X
									</button>
								)}
							</div>
						);
					})}
				</div>
			</div>
		);
	} else {
		return (
			<div style={{ margin: '100px 0px' }}>
				<h3 style={{ textAlign: 'center' }}>CARGANDO...</h3>
				<div style={{ textAlign: 'center' }}>
					<span>
						<img style={{ height: '200px', width: '200px' }} src={LoadingGIF} alt={'Cargando'} />
					</span>
				</div>
			</div>
		);
	}
};

const MenuSeguimientos = ({ scriptsNoFlujo, permisos }) => {
	const history = useHistory();
	return (
		<div>
			<h2 style={{ textAlign: 'center' }}>Seguimientos</h2>
			{scriptsNoFlujo.map((script) => {
				return (
					<div key={script._id} className={'intent'} onClick={() => permisos.modificarScripts && history.push('/scripts/' + script._id)}>
						<h2 style={{ margin: 0, marginLeft: 30 }}>{script.tipoScript}</h2>
					</div>
				);
			})}
		</div>
	);
};
